import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { PARTICIPANTS } from '../store/actionTypes';
import { Participant } from './models/participants';

export const participants = createApi({
  reducerPath: PARTICIPANTS,
  baseQuery,
  tagTypes: ['Participant'],
  endpoints: builder => ({
    getParticipant: builder.query<Participant, { participantId: string }>({
      query: variables => ({
        document: gql`
          query GetParticipant($participantId: String) {
            getParticipant(participantId: $participantId) {
              id
              guid
              provider
              thirdPartyUid
            }
          }
        `,
        variables,
      }),
      transformResponse: (response: any) => response?.getParticipant,
    }),
  }),
});

export const { useGetParticipantQuery } = participants;
